import { render, staticRenderFns } from "./GatherDialog.vue?vue&type=template&id=04e36d0b&scoped=true"
import script from "./GatherDialog.vue?vue&type=script&lang=js"
export * from "./GatherDialog.vue?vue&type=script&lang=js"
import style0 from "./GatherDialog.vue?vue&type=style&index=0&id=04e36d0b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04e36d0b",
  null
  
)

export default component.exports